import type { TOC } from '@ember/component/template-only'
import { NoDataMessage } from 'teacher-ui-client/components/no-data-message'

interface Args {
  on: boolean
}

interface Signature {
  Element: HTMLDivElement
  Args: Args
  Blocks: {
    default: unknown[]
  }
}

export const ReportingNoDataMessageIf: TOC<Signature> = <template>
  <div class="block" ...attributes>
    {{#if @on}}
      <NoDataMessage class="m-4" />
    {{else}}
      {{yield}}
    {{/if}}
  </div>
</template>

export default ReportingNoDataMessageIf
